<div style="display: flex; justify-content: center; width: 100vw; min-width: 330px;">
  <div style="width: 100%;">
    <router-outlet></router-outlet>
  </div>
</div>
